import React from "react"
import { makeStyles } from '@material-ui/core/styles';
import { Button } from "@material-ui/core";
import { withRouter } from "react-router";

function cashFromScore(score) {
  let cash = 0;
  if (score < 200) {
    cash = 20;
  } else if (score < 350) {
    cash = 30;
  } else if (score < 500) {
    cash = 40;
  } else {
    cash = 50;
  }
  return cash
}

function DonePage(props) {
    const classes = useStyles();
    const score = props.location.score
    let endText = ""
    if (props.location.sanctionGiven === "restart") {
      endText = `Vous avez maintenant terminé la reprise de la première partie. Vous avez accumulé ${score} points. Avant la poursuite de la seconde partie, veuillez répondre un questionnaire sur le déroulement de l'expérience jusqu'à présent, puis l'assistant de recherche viendra vous assister pour la fin de l'expérience et le paiement.`
    } else {
      endText = `Félicitations ! Vous avez maintenant terminé. Vous avez accumulé ${score} points. Vous recevrez donc ${cashFromScore(score)} $. Veuillez répondre à un questionnaire, puis l'assistant de recherche viendra vous assister pour la fin de l'expérience et le paiement.`
    }
    return (
        <div className={classes.root}> 
            <div>
                <p className={classes.text}>
                    {endText}
                </p>
                <p>
                    <Button className={classes.a} variant="outlined" color="primary" href="https://www.sondages.fse.ulaval.ca/ls200/index.php/972576?lang=fr">Questionnaire à répondre.</Button>
                </p>
                {/* <p>
                    J'accepte que mes données soient utilisées pour la présente recherche, passer au questionnaire
                </p> */}
                {/* <Button variant="outlined" color="primary" onClick={handleNextStep}>J'accepte</Button> */}
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    startButton:{
      margin : '5%',
      flexWrap: 'wrap'
    },
    root: {
        display: 'flex',
        flexDirection:"column",
        justifyContent:'center',
        alignItems : 'center',
        marginTop: '5vh'
      },
    text: {
        'margin': '40px 120px',
        'height': '30vh',
        'width': '60vw',
        'line-height': 1.3,
        'align-items': 'center',
        'justify-content': 'center',
        fontSize : 25
    },
    a: {
        textDecoration: 'none',
        "&:hover, &:focus": {
          fontWeight: 400
        },
        fontSize: '2rem',
      },
})

 
export default withRouter(DonePage);